import React, { useState, useEffect, useRef } from 'react';
import {
    MainContainer,
    FilterMain,
    DisplayControls,
    MainList,
    Title
} from './index.style'
import PropTypes from 'prop-types';
import Grid from '@components/Grid';
import GridItem from '@components/GridItem';
import Spacer from '@components/Spacer';
import Item from './Item'
import Display from './Display';
import ServiceFilter from './ServiceFilter';
import Filters from './Filters';
import { useStore } from '@Store/'
import { toggleDisplayList } from '@Store/'


const CaseStudies = ({ caseStudies }) => {

    const [currentFilter, setCurrentFilter] = useState("");
    const [currentServiceFilter, setCurrentServiceFilter] = useState([]);
    const [itemsArray, setItemsArray] = useState(caseStudies);
    const [uniqueTags, setUniqueTags] = useState([]);
    const [store, dispatch] = useStore()
    const {
        displayList
    } = store

    const stringToSlug = (str) => {
        return str
          .trim()
          .toLowerCase()
          .replace(/ /g, '_')
          .replace(/[^\w-]+/g, '');
    }
    

    const convertToObjects = (stringArray) => {
        return stringArray.map((string) => {
          const title = string;
          const slug = stringToSlug(string);
          return { title, slug };
        });
    };

    useEffect(() => {
        const storageDisplay = localStorage.getItem("display");
        const storageFilter = localStorage.getItem("filter");
        toggleDisplayList(dispatch,( storageDisplay === "grid") ? false: true);
        setCurrentFilter(storageFilter ? storageFilter : "");
        const allTags = caseStudies.reduce((acc, caseStudy) => {
            if (caseStudy.content && caseStudy.content.length > 0) {
              return [...acc, ...caseStudy.content[0].services];
            } else {
              return acc;
            }
        }, []);
        setUniqueTags(convertToObjects([...new Set(allTags)]));

        const queryString = window.location.search,
        urlParams = new URLSearchParams(queryString)
        if(urlParams.get('service')) {
            setCurrentServiceFilter([urlParams.get('service')])
            setCurrentFilter("");
        }
        
    }, []);

    useEffect(() => {
        filterCaseStudies(currentServiceFilter);
    } , [currentServiceFilter]);

    const changeFilter = (filterTitle) => {
        localStorage.setItem("filter", filterTitle);
        setCurrentFilter(filterTitle);
        const _ele = document.getElementById('ourWorks');
        window.scrollTo({
          top: _ele.offsetTop,
          left: 0,
          behavior: "smooth",
        });
    }

    const changeServiceFilter = (filterTitle) => {
        if(!currentServiceFilter.includes(filterTitle)) {
            setCurrentServiceFilter([...currentServiceFilter, filterTitle]);
        }else{
            setCurrentServiceFilter(currentServiceFilter.filter(filter => filter !== filterTitle))
        }
    }

    const handleActivateAll = () => {
        localStorage.setItem("filter", "");
        setCurrentFilter("");
    };
    
    const filterCaseStudies = (originalArray) => {
        const filterStrings = originalArray.reduce((acc, item) => {
            if (!acc.includes(item)) {
                acc.push(item);
            }
            return acc;
        }, []);
        if (filterStrings[0] && filterStrings.length > 0) {
            const newCaseStudies = caseStudies.filter((caseStudy) => {
                if (caseStudy.content && caseStudy.content.length > 0) {
                    const services = caseStudy.content[0].services || [];
                    
                    const matchingService = filterStrings.some((filterString) => {
                        if(filterString) {
                            return services.some((service) =>
                                stringToSlug(service).includes(filterString)
                            );
                        }
                    });
                    
                    return matchingService;
                }
            });
            setItemsArray(newCaseStudies);
        }else {
            setItemsArray(caseStudies);
        }
    };

    return (
        <MainContainer id="ourWorks">
            <FilterMain>
                <Title>Filter by:</Title>
                <Filters changeFilter={changeFilter} handleActivateAll={handleActivateAll} currentFilter={currentFilter}/>
                <ServiceFilter items={uniqueTags} setCurrentServiceFilter={changeServiceFilter} currentServiceFilter={currentServiceFilter}/>
                <Display />
            </FilterMain>
            <MainList className="mainPin" id="displayParent">
                <Spacer size={[1, 80]} />
                <Grid className={displayList ? 'listMain' : 'gridMain'} columnCount={12}>
                    {itemsArray?.map((item) => (
                        <>
                            {(currentFilter !== '') ?
                                (item.metadata.tags.filter(e => currentFilter === e.name).length > 0) ?
                                    (<GridItem tabletL={displayList ? 12 : 4} key={item.slug}><Item data={item} display={displayList ? 'list' : 'grid'} /></GridItem>)
                                    : null
                                :
                                (<GridItem tabletL={displayList ? 12 : 4} key={item.slug}><Item data={item} display={displayList ? 'list' : 'grid'} /></GridItem>)
                            }
                        </>
                    ))}
                </Grid>
                <Spacer size={[50, displayList ? 40 : 90]} />
                <div className="endTrigger"></div>
                <Spacer size={60} />
            </MainList>
        </MainContainer>
    );
};

CaseStudies.propTypes = {
    caseStudies: PropTypes.array,
};

export default CaseStudies;